module.exports = __webpack_public_path__ + "img/app_star.ac20c627.png";